import { render, staticRenderFns } from "./tan_needGz_list_moon.vue?vue&type=template&id=3e476c9a&scoped=true"
import script from "./tan_needGz_list_moon.vue?vue&type=script&lang=js"
export * from "./tan_needGz_list_moon.vue?vue&type=script&lang=js"
import style0 from "./tan_needGz_list_moon.vue?vue&type=style&index=0&id=3e476c9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e476c9a",
  null
  
)

export default component.exports